export enum ColorType {
  EER = 'EER_COLORS',
  EIR = 'EIR_COLORS',
}
